import React from 'react'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { StompProvider } from 'lib/stompContext'
import { createRoot } from 'react-dom/client'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import App from 'features/App/App'

if (process.env.NODE_ENV !== 'development') {
	Sentry.init({
		dsn: 'https://3f1365b25bb04622ab6fd58e11de3804@o558011.ingest.sentry.io/5693636',
		integrations: [new Integrations.BrowserTracing()],
		normalizeDepth: 10,

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0,
	})

	datadogRum.init({
		applicationId: '310fe065-ed7f-400d-972f-6e44c8a6d832',
		clientToken: 'pub842fb515acfc0e7d67d2f3a88438f409',
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: 'datadoghq.eu',
		service: 'gummidata-stock-ui',
		env: process.env['NODE_ENV'],
		// Specify a version number to identify the deployed version of your application in Datadog
		version: process.env['REACT_APP_VERSION'],
		sessionSampleRate: 100,
		sessionReplaySampleRate: 20,
		defaultPrivacyLevel: 'mask-user-input',
	})

	datadogLogs.init({
		clientToken: 'pub842fb515acfc0e7d67d2f3a88438f409',
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: 'datadoghq.eu',
		forwardErrorsToLogs: true,
		sessionSampleRate: 100,
		env: process.env['NODE_ENV'],
		service: 'gummidata-stock-ui',
		version: process.env['REACT_APP_VERSION'],
	})
}

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<Sentry.ErrorBoundary>
				<StompProvider>
					<App />
				</StompProvider>
			</Sentry.ErrorBoundary>
		</Provider>
	</React.StrictMode>
)
